import React, { useEffect, useState } from "react"
import Input from "../input";

const baseCSSClassname = "table";
const defaultContainerStyle = {
    height: "80vh",
    overflowY: "hidden"
}

const Table = ({ className, headerMap, headers, data, rowHover, showFilters = false, filterByValue={}, filterByValueFunc=null, usePagination = false, pageSize = 10,
    title,
    containerStyle,
    tableActions = []
}) => {

    containerStyle = !!containerStyle ? {...defaultContainerStyle, ...containerStyle} : defaultContainerStyle  

    className = `${baseCSSClassname} ${className ? className : ""}`

    const [filteredData, setFilteredData] = useState(null)
    const [filters, setFilters] = useState({})
    const [pageNo, setPageNo] = useState(0)

    const handleFilterEffect = () => {
        let isFilterApplied = !!Object.keys(filters).length && Object.values(filters).reduce((acc, value) => !!acc && !!value, true)
        isFilterApplied = !!Object.keys(filterByValue).length && Object.values(filters).reduce((acc, value) => !!acc && !!value, true)
        if (!isFilterApplied) return setFilteredData(null);

        let temp = data;

        for (let filter in filters) {

            temp = temp.filter(v => {
                let value = v[filter];
                if (React.isValidElement(value)) {
                    value = value.props.children
                }
                return value.toString().toLowerCase().indexOf(filters[filter].toLowerCase()) != -1
            })
        }

        if(filterByValueFunc){
            temp = filterByValueFunc(temp);
        }
        setFilteredData([...temp])
    }

    useEffect(handleFilterEffect, [filters, filterByValue, data, pageNo])

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFilters({
            [name]: value
        })
    }

    const tableData = (filteredData ?? data)
    const dataToRender = usePagination ? [].slice(pageNo * pageSize, (pageNo + 1) * pageSize) : tableData

    const showHeader = title || !!tableActions.length;


    return (
        <div className={className} style={containerStyle}>
            {
                showHeader && (
                    <div className={`${baseCSSClassname}-header`}>
                        {
                            !title ? undefined : (
                                <div className={`${baseCSSClassname}-title`}>
                                    {title}
                                </div>
                            ) 
                        }
                        {
                            !!tableActions.length && (
                                <div className={`${baseCSSClassname}-actions`}>
                                    {tableActions}
                                </div>
                            )
                        }
                    </div>
                )
            }
            {
                showFilters && (

                    <div className={`${baseCSSClassname}-filters`}>
                        {
                            headers.map((key, i) => {
                                if (headerMap && !headerMap[key].filter) return null;

                                if (!headerMap) return <div key={key}>
                                    <input  name={key} value={filters[key]} onChange={handleChange} />
                                </div>


                                return <Input.TextInput
                                        leading={headerMap[key].label}
                                        name={key} value={filters[key]} onChange={handleChange}
                                    />
                            })
                        }
                    </div>
                )
            }
            <div className={`${baseCSSClassname}-container`}>
                <table>
                    {
                        headers && <thead>
                            <tr className={`${baseCSSClassname}-head-label-row`}>
                                {
                                    headers.map((key, i) => {
                                        if (!headerMap) return <th key={key}>{key}</th>
                                        return <th key={key}>{headerMap[key].label}</th>
                                    })
                                }
                            </tr>
                        </thead>
                    }

                    {
                        data && <tbody>
                            {
                                dataToRender.map(v => {
                                    return <tr key={v._id} className={rowHover ? `table--hover--${rowHover}` : ""}>{
                                        headers ?
                                            headers.map(key => {
                                                return <td key={key}>{v[key]}</td>
                                            })
                                            :
                                            Object.keys(v).map(key => {
                                                return <td key={key}>{v[key]}</td>
                                            })
                                    }</tr>
                                })
                            }
                        </tbody>
                    }
                </table>
            </div>
            <div className={`${baseCSSClassname}-pagination`}>
                Showing {pageNo * pageSize + 1} to {pageNo * pageSize + tableData.length} of {tableData.length} entries
                {
                    usePagination && (
                        <div>Page no</div>
                    )
                }
            </div>
        </div>
    )

}

export default Table